import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { SipProfileRead } from '@ragu-components/ord-types';

const SipProfilesList = React.lazy(async () => import('./SipProfilesList'));

export const sipProfilesResources: OrdResourceProps = {
  key: Resources.sip_profiles,
  name: Resources.sip_profiles,
  list: <SipProfilesList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: SipProfileRead) => record.name,
};
